<template>
<div>
  <h1> Profile for user '{{my_user}}' </h1>
  <hr style='width: 100%'>
  Find below instructions on how to query protected information from metaflammation database.
  <br/>
  <br/>
  <h3> Personal Bearer (OAuth) security token: </h3>
  <p style="font-size: 0.75em"> <tt> {{my_token}} </tt> </p>
  <h3> Example query of protected resource </h3>
  <p style="font-size: 0.75em"> <tt> curl -H "Authorization: Bearer {{ my_token }}" https://sfb1454.iaas.uni-bonn.de/database/api/query/secret_resource </tt> </p>
    <v-btn type="submit" color="red" value="Logout" @click="logout"> Logout </v-btn>
</div>
</template>

<script>
export default {
  data () {
    return {
      my_token: this.$store.getters.isLoggedIn,
      my_user: this.$store.getters.getUser
    }
  },
  async created () {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/login')
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
      this.$router.push('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ProfileComponent.vue